import { FilterPopover, NO_AUTOFILL, type Align, type SortProps } from './FilterPopover';

export interface TextIncludeExcludeValue {
  contains: string | null;
  excludes: string | null;
}

const EMPTY: TextIncludeExcludeValue = { contains: null, excludes: null };

interface Props extends SortProps {
  label: string;
  align?: Align;
  value: TextIncludeExcludeValue;
  onChange: (next: TextIncludeExcludeValue) => void;
  containsLabel?: string;
  excludesLabel?: string;
  containsPlaceholder?: string;
  excludesPlaceholder?: string;
}

/** Free-text column filtered by "contains" and/or "does not contain" (both must hold). */
export function TextIncludeExcludeFilterPopover({
  label,
  align,
  value,
  onChange,
  containsLabel = 'Contains',
  excludesLabel = 'Does not contain',
  containsPlaceholder,
  excludesPlaceholder,
  ...sortProps
}: Props) {
  return (
    <FilterPopover<TextIncludeExcludeValue>
      label={label}
      align={align}
      {...sortProps}
      filterActive={!!value.contains || !!value.excludes}
      value={value}
      emptyValue={EMPTY}
      onChange={(v) => onChange({ contains: v.contains?.trim() || null, excludes: v.excludes?.trim() || null })}
      isEmpty={(d) => !d.contains?.trim() && !d.excludes?.trim()}
      render={({ draft, setDraft }) => (
        <div className="column-filter-stack">
          <label className="column-filter-field">
            <span className="column-filter-field-label">{containsLabel}</span>
            <input
              type="text"
              className="column-filter-input"
              {...NO_AUTOFILL}
              value={draft.contains ?? ''}
              onChange={(e) => setDraft({ ...draft, contains: e.target.value || null })}
              placeholder={containsPlaceholder}
              autoFocus
            />
          </label>
          <label className="column-filter-field">
            <span className="column-filter-field-label">{excludesLabel}</span>
            <input
              type="text"
              className="column-filter-input"
              {...NO_AUTOFILL}
              value={draft.excludes ?? ''}
              onChange={(e) => setDraft({ ...draft, excludes: e.target.value || null })}
              placeholder={excludesPlaceholder}
            />
          </label>
        </div>
      )}
    />
  );
}
